import { ReportFilesPostResponse, ReportFilesPostRequest } from '@/dtos/report-files/post'
import { ReportFilesSearchPostRequest, ReportFilesSearchPostResponse } from '@/dtos/report-files/search/post'
import { ReportFileTaskStatusPutRequest, ReportFileTaskStatusPutResponse } from '@/dtos/report-files/put'
import { APIClientBase } from './api-client-base'

class ReportFilesClient extends APIClientBase {
  constructor() {
    super('/report-files')
  }

  // 報告書アップロード
  async postReportFiles(req: ReportFilesPostRequest) : Promise<ReportFilesPostResponse | void> {
    return this.post('', req, ReportFilesPostResponse)
  }

  // 報告書一覧検索
  postReportFilesSearch(req: ReportFilesSearchPostRequest): Promise<ReportFilesSearchPostResponse | void> {
    return this.post('search', req, ReportFilesSearchPostResponse)
  }

  // 報告書ステータス更新
  putReportFileTaskStatus(req: ReportFileTaskStatusPutRequest): Promise<ReportFileTaskStatusPutResponse | void> {
    const { reportUploadId, ...body } = req
    return this.put(`/task-status/${reportUploadId}`, body, ReportFileTaskStatusPutResponse)
  }
}

export const reportFilesClient = new ReportFilesClient()
